// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3seyt","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2Ms1P","gfeWrapper":"CalendarEvent_gfeWrapper__mo12U"};